
import React from "react";
import { useParams } from 'react-router-dom'
import { Helmet } from "react-helmet-async";
import { copy } from 'copy-anything'
import {
  Button,
  Container,
  Modal, ModalHeader, ModalBody, ModalFooter
} from "reactstrap";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// core components
import DemoNavbar from "components/Navbars/DemoNavbar.js";
import SimpleFooter from "components/Footers/SimpleFooter.js";
import Cookies from "universal-cookie";
const cookies = new Cookies();
function withParams(Component) {
  return props => <Component {...props} params={useParams()} />;
}
class ProductCat extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      package: null,
      customerDetailsModal: false,
      customerDetails: [
        { name: 'occationType', label: "Occasion Type", value: 'Wedding', mandatory: false, type: 'select', error: false },
        { name: 'occationDate', label: "Occasion Date", value: "", mandatory: true, type: 'date', error: false },
        { name: 'name', label: "Name", value: '', mandatory: true, type: 'text', error: false },
        { name: 'address', label: "Address", value: '', mandatory: false, type: 'text', error: false },
        { name: 'city', label: "City", value: '', mandatory: false, type: 'text', error: false },
        { name: 'state', label: "State", value: '', mandatory: false, type: 'text', error: false },
        { name: 'pin', label: "Pin Code", value: '', mandatory: true, type: 'pincode', error: false }
      ],
      customerDetailsSubmit: false,

    }
    //this.myRef = React.createRef()
    this.exportRef = React.createRef();
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    // this.loadPackage(id)
    let data = localStorage.getItem('porinoyMyPackage')
    if (data !== null) {
      let pckData = JSON.parse(data)
      fetch('../API/weddingPackage.json', {
      })
        .then((response) => response.json())
        .then((responseJson) => {
          let tempData = responseJson;
          tempData.forEach((item, index) => {
            if (item.id === parseInt(pckData.id)) {
              item.step.forEach((stepitems, stepindex) => {
                let checkOldStep = pckData.step.filter((pf) => pf.id === stepitems.id)
                if (checkOldStep.length > 0 && checkOldStep[0].selected && checkOldStep[0].selected.length > 0) {
                  stepitems.selected = checkOldStep[0].selected
                }

              })
              this.state.package = item
              this.setState({
                package: this.state.package
              })
            }
          })



        })
        .catch(error => {
          console.log(error);
        })

    }


  }

  loadPackage = (id) => {
    fetch('../API/weddingPackage.json', {
    })
      .then((response) => response.json())
      .then((responseJson) => {
        let tempData = responseJson;
        tempData.forEach((item, index) => {
          if (item.id === parseInt(id)) {
          }
        })



      })
      .catch(error => {
        console.log(error);
      })
  }
  isValidPinCode = (str) => {
    // Regex to check valid
    // Pincode of India
    let regex = new RegExp(/^[1-9]{1}[0-9]{2}\s{0,1}[0-9]{3}$/);

    // if str
    // is empty return false
    if (str == null) {
      return "false";
    }

    // Return true if the str
    // matched the ReGex
    if (regex.test(str) == true) {
      return "true";
    }
    else {
      return "false";
    }
  }
  onchange = (e, ind) => {
    let name = e.target.name;
    let val = e.target.value;
    this.state.customerDetails[ind].value = val
    if (this.state.customerDetailsSubmit) {
      if (this.state.customerDetails[ind].mandatory === true) {
        if (ind !== 6) {
          if (this.state.customerDetails[ind].value === '') {
            this.state.customerDetails[ind].error = true
          } else {
            this.state.customerDetails[ind].error = false
          }
        } else {
          if (this.state.customerDetails[ind].value === '') {
            this.state.customerDetails[ind].error = true
          } else {
            let isvalid = this.isValidPinCode(this.state.customerDetails[ind].value)
            if (isvalid !== "true") {
              this.state.customerDetails[ind].error = true
            } else {
              this.state.customerDetails[ind].error = false
            }
          }
        }

      }

    }
    this.setState({
      customerDetails: this.state.customerDetails
    })
  }
  sendOrder = () => {
    let baseUrl = 'https://wa.me/919614292911?text=';

    let message = `New Package Order from https://porinoy.in\n`;
    message += `Package Name - ${this.state.package.name}\n`;
    message += `Package Price - ${this.state.package.price}\n`;
    message += `Package Details -\n`;
    message += `------------------------\n`
    this.state.package.step.forEach((item) => {
      if (item.selected) {
        message += `${item.name} (${item.total})\n`;

        if (item.type.toLowerCase() === 'card' && item.selected?.length > 0) {
          message += `https://www.porinoy.in/product-details/${item.selected[0].id}\n`;
          message += `------------------------\n`
        }

        if (item.type.toLowerCase() === 'accessories' && item.selected?.length > 0) {
          message += `https://www.porinoy.in/accessories-details/${item.selected[0].id}\n`;
          message += `------------------------\n`
        }
      }

    });
    message += `Customer Details\n`
    message += `------------------------\n`
    this.state.customerDetails.forEach((item, index) => {
      if (index !== 0) {
        if (item.value !== '') {
          message += `${item.label}  -  ${item.value}\n`;
        }
      }
    })

    const encodedMessage = encodeURIComponent(message);
    window.open(baseUrl + encodedMessage, '_blank');
  };

  orderPackage = () => {
    let data = this.state.package
    if (data && data.step && data.step.length) {
      let checkValid = []
      let checkInValid = []
      data.step.forEach((item) => {
        if (item.selected) {
          if (item.selected.length) {
            checkValid.push(item)
          } else {
            checkInValid.push(item)
          }
        } else {
          checkInValid.push(item)
        }
      })
      // this.openModalCustomerDetail()
      if (checkInValid.length > 0) {
        toast.error('You have ' + checkInValid.length + ' item pending for choose. Please chhose all the product and try again.', { containerId: "mypackage" })
      } else {
        this.openModalCustomerDetail()
      }

    }
  }
  submitCutomerForm = () => {
    if (this.state.customerDetails[1].value === '') {
      this.state.customerDetails[1].error = true
    } else {
      this.state.customerDetails[1].error = false;
      console.log(this.state.customerDetails[1].value)
    }
    if (this.state.customerDetails[2].value === '') {
      this.state.customerDetails[2].error = true
    } else {
      this.state.customerDetails[2].error = false;
      console.log(this.state.customerDetails[2].value)
    }
    if (this.state.customerDetails[6].value === '') {
      this.state.customerDetails[6].error = true
    } else {
      let isvalid = this.isValidPinCode(this.state.customerDetails[6].value)
      if (isvalid !== "true") {
        this.state.customerDetails[6].error = true
      } else {
        this.state.customerDetails[6].error = false
      }
    }
    let checkError = [];
    this.state.customerDetails.forEach((item) => {
      if (item.mandatory) {
        if (item.error) {
          checkError.push(item.name)
        }
      }
    })

    this.setState({
      customerDetailsSubmit: true,
      customerDetails: this.state.customerDetails
    })
    if (checkError.length === 0) {
      this.sendOrder()
      console.log(this.state.customerDetails)

    }

  }
  openModalCustomerDetail = (url) => {
    this.setState({
      customerDetailsModal: true
    })
  }
  toggleModalCustomerDetail = () => {
    this.setState({
      customerDetailsModal: !this.state.customerDetailsModal
    })
  }
  render() {
    let data = this.state.package

    const colors = ["#f39c12", "#e74c3c", "#d35400", "#27ae60", "#3498db"];
    return (

      <>
        <ToastContainer
          containerId={'mypackage'}
        />
        <DemoNavbar />
        <main ref="main">
          <section
            style={{ backgroundImage: "url(images/inner-banner-bg.webp)", backgroundPosition: "center", backgroundSize: "cover" }}
            className="section pageTitleBG">
            <div className="row m-0">
              <div className="col-12 text-center">
                <h1 style={{ fontWeight: "500" }} className="h1 text-center text-uppercase mb-0">My Package </h1>
                <div className="h3"> {data !== null && data.name}</div>
              </div>
              <div className="col-12 text-center">
                <button
                  onClick={() => {
                    localStorage.removeItem("porinoyMyPackage", { path: '/' })
                    window.location = '/'
                  }}
                  className="btn btn-danger rounded-pill text-uppercase  btn-lg my-1">Remove Package</button>
                <button
                  onClick={() => this.orderPackage()}
                  className="btn btn-danger rounded-pill text-uppercase  btn-lg my-1">Order Package</button>
              </div>


            </div>
          </section>

          <section className="section ">
            <Container fluid>
              <div className="row">
                <div className="col-12">
                  <div className="timeline">
                    {data !== null && data.step.map((item, index) => {
                      const color = colors[index % colors.length];
                      return (
                        <div key={index} className="timeline-item">

                          {/* Icon circle */}
                          <div
                            className="timeline-icon"
                            style={{ borderColor: color, color: color }}
                          >

                          </div>

                          {/* Content box */}
                          <div className="timeline-content">
                            <div className="timeline-title">{item.name}</div>
                            <div
                              className="timeline-header"
                              style={{ backgroundColor: color }}
                            ></div>
                            <div
                              className="timeline-thumb"
                              style={{
                                borderColor: color,
                                color: color,
                                backgroundImage: item.selected && item.selected.length > 0 ? "url('" + item.selected[0].thumb + "')" : "url('" + item.thumb + "')",
                                backgroundPosition: "center",
                                backgroundSize: "cover"
                              }}
                            ></div>
                            <div className="timeline-bottons" style={{ paddingTop: "220px" }}>

                              <button
                                onClick={() => {
                                  let itemcat = item.category.join();
                                  let type = item.type
                                  let packageid = data.id
                                  let minPrice = item.minPrice
                                  let maxPrice = item.maxPrice
                                  let stepID = item.id
                                  let tag = item.tag || ""
                                  let preparedata = btoa(type + "*" + itemcat + "*" + packageid + "*" + minPrice + "*" + maxPrice + "*" + stepID + "*" + tag)

                                  window.location = '/my-package-products/' + preparedata
                                }}
                                style={{ padding: "0.625rem 1.25rem" }}
                                className="btn btn-danger rounded-pill text-uppercase  btn-lg my-1">Explore Items</button>
                              {item.selected && item.selected.length > 0 &&

                                <button
                                  style={{ padding: "0.625rem 1.25rem" }}
                                  onClick={() => {
                                    if (item.type.toLowerCase() === 'card') {
                                      window.location = '/product-details/' + item.selected[0].id
                                      //window.open('/product-details/' + item.selected[0].id, '_blank');
                                    }
                                    if (item.type.toLowerCase() === 'accessories') {
                                      window.location = '/accessories-details/' + item.selected[0].id
                                      // window.open('/accessories-details/' + item.selected[0].id, '_blank');
                                    }

                                  }}
                                  className="btn btn-danger rounded-pill text-uppercase  btn-lg my-1">Your Item</button>


                              }
                              {item.selected && item.selected.length > 0 &&
                                <button
                                  onClick={() => {
                                    let modata = this.state.package
                                    modata.step.forEach((modItem, modIndex) => {
                                      if (modIndex === index) {
                                        modItem.selected = null
                                      }
                                    })
                                    this.state.package = modata
                                    localStorage.setItem("porinoyMyPackage", JSON.stringify(this.state.package))
                                    this.setState({
                                      package: this.state.package
                                    })
                                  }}
                                  style={{ padding: "0.625rem 1.25rem" }} className="btn btn-dark  rounded-pill text-uppercase  btn-lg"><i class="fas fa-trash"></i></button>
                              }
                            </div>
                          </div>
                        </div>
                      )
                    })}
                  </div>
                </div>
                {/* {data !== null && data.step.map((item, index) => {
                  return <div key={index} className="col-4 mb-3">
                    <div className="card shadow">
                      <div className="card-header h5 bg-white"> {item.name}
                      </div>

                      <div className="card-body ">

                        {item.thumb && item.thumb !== "" &&
                          <div className="position-relative">
                            <img className="w-100" src={item.thumb} />
                            <div className="h4 mb-0 mt-2">{item.total} pcs </div>
                          </div>
                        }
                      </div>
                    </div>

                  </div>
                })} */}
                <div className="col-12 text-center mt-3"> <button onClick={() => this.orderPackage()} className="btn btn-danger rounded-pill text-uppercase  btn-lg">Order Package</button></div>

              </div>
            </Container>
          </section>
        </main>
        <SimpleFooter />
        <Modal centered size="lg" isOpen={this.state.customerDetailsModal} toggle={this.toggleModalCustomerDetail}>
          <ModalBody>
            <span onClick={this.toggleModalCustomerDetail} className="closeModal"><i class="fa-solid fa-circle-xmark"></i></span>
            <div className="row">
              {/* <div className="col-12 col-lg-4 col-xl-4 ">
                      <div class="form-floating mb-3">
                        <select
                          onChange={(e) => this.onchange(e, 0)}
                          value={this.state.customerDetails[0].value}
                          placeholder={this.state.customerDetails[0].label}
                          className="form-select"
                        >
                          <option className="Wedding">Wedding</option>
                          <option className="Reception">Reception</option>
                        </select>
                        <label >{this.state.customerDetails[0].label} </label>
                      </div>
                    </div> */}
              <div className="col-12 col-lg-6 col-xl-6 ">
                <div class="form-floating mb-3">
                  <input onChange={(e) => this.onchange(e, 1)} value={this.state.customerDetails[1].value} type="date" class={this.state.customerDetails[1].error === true ? "form-control is-invalid" : "form-control"} placeholder={this.state.customerDetails[1].label} />
                  <label >{this.state.customerDetails[1].label} <span className="text-danger">*</span></label>
                </div>
              </div>
              <div className="col-12 col-lg-6 col-xl-6 ">
                <div class="form-floating mb-3">
                  <input onChange={(e) => this.onchange(e, 2)} value={this.state.customerDetails[2].value} type="text" class={this.state.customerDetails[2].error === true ? "form-control is-invalid" : "form-control"} placeholder={this.state.customerDetails[2].label} />
                  <label >{this.state.customerDetails[2].label} <span className="text-danger">*</span></label>
                </div>
              </div>
              <div className="col-12 col-lg-12 col-xl-12 ">
                <div class="form-floating mb-3">
                  <input onChange={(e) => this.onchange(e, 3)} value={this.state.customerDetails[3].value} type="text" class="form-control" placeholder={this.state.customerDetails[3].label} />
                  <label >{this.state.customerDetails[3].label} </label>
                </div>
              </div>
              <div className="col-12 col-lg-4 col-xl-4 ">
                <div class="form-floating mb-3">
                  <input onChange={(e) => this.onchange(e, 4)} value={this.state.customerDetails[4].value} type="text" class="form-control" placeholder={this.state.customerDetails[4].label} />
                  <label >{this.state.customerDetails[4].label} </label>
                </div>
              </div>
              <div className="col-12 col-lg-4 col-xl-4 ">
                <div class="form-floating mb-3">
                  <input onChange={(e) => this.onchange(e, 5)} value={this.state.customerDetails[5].value} type="text" class="form-control" placeholder={this.state.customerDetails[5].label} />
                  <label >{this.state.customerDetails[5].label} </label>
                </div>
              </div>
              <div className="col-12 col-lg-4 col-xl-4 ">
                <div class="form-floating mb-3">
                  <input onChange={(e) => this.onchange(e, 6)} value={this.state.customerDetails[6].value} type="number" class={this.state.customerDetails[6].error === true ? "form-control is-invalid" : "form-control"} placeholder={this.state.customerDetails[6].label} />
                  <label >{this.state.customerDetails[6].label} <span className="text-danger">*</span></label>
                </div>
              </div>
              <div className="col-12 col-lg-4 col-xl-4 ">
                <button onClick={() => this.submitCutomerForm()} className="btn btn-danger">Submit</button>
              </div>
            </div>
          </ModalBody>

        </Modal>
      </>
    );
  }
}
export default withParams(ProductCat);
